import { SubordinatedEmployeeDto } from '@/modules/employees/models/SubordinatedEmployee'
import dayjs from 'dayjs'
import * as XLSX from 'xlsx'

export const assignedEmployeesReportXlsx = (
  filteredEmployees: SubordinatedEmployeeDto[]
) => {
  if (!filteredEmployees) {
    console.error('No filtered employees available')
    return
  }

  const employees = filteredEmployees

  const transformedData = employees.map((employee: SubordinatedEmployeeDto) => {
    return {
      Nomina: employee.payroll.code,
      'Codigo Empleado': employee.code,
      'Nombre Empleado': employee.name,
      'Fecha de ingreso': employee.joiningDate,
      'Saldo de vacaciones': employee.vacationBalance,
      Area: employee.area,
      Departamento: employee.department,
      Dirección: employee.direction,
    }
  })

  const worksheet = XLSX.utils.json_to_sheet(transformedData)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Empleados-Asignado')
  XLSX.writeFile(
    workbook,
    'Empleados-Asignados-' + dayjs().format('DD-MM-YYYY') + '.xlsx'
  )
}
